import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	accordion: {
		borderLeft: "3px solid",
		borderColor: colors.blue[900]
	},
	accordionDetailsTitle: {
		fontSize: 20,
		color: colors.gray[600],
		fontWeight: 500
	},
	accordionSummaryChip: {
		background: colors.blue[100],
		color: colors.blue[900]
	},
	accordionSummaryChipIcon: {
		marginLeft: 8,
		width: 14
	},
	accordionSummaryIcon: {
		color: colors.blue[900]
	}
}))

export default useStyles
